import React, { forwardRef, ReactNode } from 'react';

import Box, { BoxProps } from '@mui/material/Box';
import Stack from '@mui/material/Stack';

interface Props {
  children: ReactNode;
  noPadding?: boolean;
  sx?: BoxProps['sx'];
}

export const MainContainer = forwardRef<HTMLDivElement, Props>(
  ({ children, noPadding, sx }, ref) => {
    return (
      <Box
        component="main"
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          maxHeight: '100%',
          minHeight: 0,
          overflow: 'auto',
          width: '100%',
          ...sx,
        }}
      >
        <Stack
          ref={ref}
          sx={{
            height: '100%',
            minHeight: 300,
            overflow: 'auto',
            paddingBottom: noPadding ? 0 : 5,
            paddingTop: noPadding ? 0 : 3,
            paddingX: noPadding ? 0 : 3,
          }}
        >
          {children}
        </Stack>
      </Box>
    );
  },
);
